class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (document.querySelector('.js-topWorks')) {
      new TopWorks('.js-topWorks');
    }
    if (document.querySelector('.js-topInterview')) {
      new TopInterview('.js-topInterview');
    }
  }
}
